import React, { createContext, useState, useContext } from 'react';
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('Eng'); 
    const changeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
    };
    
    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
export const useLanguage = () => useContext(LanguageContext);
